export default "__VITE_ASSET__BsutdQL9__"